export default function replaceLinks() {
    const baseUrl = process.env.PUBLIC_URL
    const links = document.querySelectorAll("a");
    
    
    links.forEach(link => {
        let href = link.getAttribute("href");
        
        if (href && !href.startsWith("http") && !href.startsWith("www") && !href.startsWith(baseUrl)) {
            href = href.replace(/^/, baseUrl);
            link.setAttribute("href", href);
        }
    });
    
    document.querySelectorAll('a[href$=".fig"]').forEach((link) => {
        const filename = link.pathname.split("/").pop();
        const foldername = filename.replace(".fig", ""); 
        const realUrl = `/docs/diretrizes/projects/diretrizes/componentes/${foldername}/src/${filename}`
        link.href = realUrl
  });
}
